// Interval (ms) between each increment of the progress bar during upload.
export const PROGRESS_TICK_INTERVAL_MS = 900

// Minimum duration (ms) for displaying the sending animation, even if the API responds faster.
export const MIN_TRANSMISSION_DURATION_MS = 3000

// Maximum level the bar can “artificially” reach before the transmission actually ends.
export const PROGRESS_CAP_BEFORE_COMPLETE = 85

//  Delay (ms) before redirecting the user after a successful transmission.
export const NAVIGATE_AFTER_SUCCESS_DELAY_MS = 1500

// Special request keys used to restore the user's progress upon reloading.
export const CURRENT_QUESTION_KEY = '__currentQuestionId__'
export const SKIPPED_QUESTIONS_KEY = '__skippedQuestionIds__'

// Position value saved under CURRENT_QUESTION_KEY when the user left from the recap screen.
export const RECAP_POSITION = '__recap__'
